import { render, staticRenderFns } from "./Webshops.vue?vue&type=template&id=737d4f54&"
import script from "./Webshops.vue?vue&type=script&lang=js&"
export * from "./Webshops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports